// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"pen-ball"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M14.5 5L19 9.5L7.5 21L3.00049 21.0006L3.00049 16.5L14.5 5Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M17 2.5L21.5 7M14.5 5L19 9.5L7.5 21L3.00049 21.0006L3.00049 16.5L14.5 5Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M21.5 12L15.5 18","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-pen-ball')
export default class PenBallIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'pen-ball',
    }
  }
}
